import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger.js";
import {isTablet} from "../helpers";

export function initImacScene() {
    if (!$('.imac-block').length) {
        return;
    }

    gsap.registerPlugin(ScrollTrigger);

    const $block = $('.imac-block');
    const $textBlock = $block.parents('.container').find('[data-text]')

    const images = JSON.parse($block.attr('data-images'))
    let texts = []
    try {
        texts = JSON.parse($block.attr('data-texts')) || []
    } catch (e) {
        console.warn(e)
    }

    if (!images.length) $block.parents().remove();
    const timelines = [];

    const percent = 100 / images.length;

    ScrollTrigger.matchMedia({
        '(min-width: 1024px)': initDesktop,
        '(max-width: 1023px)': initMobile
    });

    let timeline = undefined;

    function initMobile() {
        timeline = gsap.timeline({
            scrollTrigger: {
                trigger: $('.imac-block').parents('.section'),
                start: `center 70%`,
                end: `center +=${percent}%`,
                scrub: true,
                invalidateOnRefresh: true,
            },
        });

        initGsap();
    }

    function initDesktop() {
        timeline = gsap.timeline({
            scrollTrigger: {
                trigger: $('.imac-block'),
                scroller: isTablet() ? '' : '.scroller',
                start: `center center+=15%`,
                pin: '.imac-block',
                end: `center -${percent * images.length}%`,
                scrub: true,
                invalidateOnRefresh: true,
            },
        });

        initGsap()
    }

    function initGsap() {
        for (let i = 0; i < images.length; i++) {
            $block.append(`<div class="imac-image-inner image-${i}" style='background-image: url("${images[i]}"); z-index: ${images.length - i}'></div>`);

            if (texts.length) {
                $textBlock.append(`<span class="imac-text ${i === 0 ? '' : 'hide'} text-${i}">${texts[i]}</span>`)
            }

            timelines.push(timeline.to($(`.imac-image-inner.image-${i}`), {
                    opacity: 1,
                    zIndex: images.length - i,
                    onUpdate: function () {
                        if (texts.length) {
                            $textBlock.find(`.imac-text.text-${i}`).removeClass('hide').siblings('.imac-text').addClass('hide')
                        }
                    },
                }).to($(`.imac-image-inner.image-${i}`), {
                    opacity: () => i === images.length - 1 ? 1 : 0,
                    zIndex: images.length - i,
                })
            )
        }
    }
}
